const RATE_30_PERCENT = 0.3
const RATE_16_5_PERCENT = 0.165
const RATE_0_PERCENT = 0

// 受客(税込30%)
// 送客手数料率(税込) = 0.3
export function calcCustomerTransferFeeRate30Percent(): number {
  return RATE_30_PERCENT
}

// 受客(税込16.5%)
// 送客手数料率(税込) = 0.165
export function calcCustomerTransferFeeRate16_5Percent(): number {
  return RATE_16_5_PERCENT
}

// 受客(税込0%)
// 送客手数料率(税込) = 0
export function calcCustomerTransferFeeRate0Percent(): number {
  return RATE_0_PERCENT
}
